document.addEventListener("DOMContentLoaded", function() {
  var acc = document.getElementsByClassName("cart-accordion");

  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("cartactive");
      var expanded = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", !expanded);
      
      var panelId = this.getAttribute("aria-controls");
      var panel = document.getElementById(panelId);
      
      if (panel) {
        if (expanded) {
          panel.style.maxHeight = null;
          panel.setAttribute("aria-hidden", "true");
        } else {
          // Check if panel.scrollHeight is defined
          if (panel.scrollHeight) {
            panel.style.maxHeight = panel.scrollHeight + "px";
            panel.setAttribute("aria-hidden", "false");
          } else {
            console.error("panel.scrollHeight is not available for:", panel);
          }
        }
      } else {
        console.error("Panel with ID '" + panelId + "' not found.");
      }
    });
  }
});